import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import AddDepartment from "./AddDepartment";
import UpdateDepartment from "./UpdateDepartment";
import { SocketContext } from "../../../context/SocketContext";
import { isAuthenticated } from "../../../commons/Auth/auth";
import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import GeneralTable from "../../../commons/GeneralTable";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { useTranslation } from "react-i18next";
import PageToolbar from "../../../design-system/PageToolbar";

const Departments = () => {
  const { t } = useTranslation("dashboard");
  const socket = useContext(SocketContext);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(9);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/departments/limited`,
        {
          serviceProvider: isAuthenticated()?.serviceProviderId,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/departments/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const refreshData = () => {
    getData();
  };

  useEffect(() => {
    if (socket) {
      socket.on("refresh service provider data", msg => {
        if (msg) {
          refreshData();
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    refreshData();

    return () => {};
  }, [searchText, pageNo]);

  const columns = [
    {
      title: t("Title"),
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      title: t("Address"),
      dataIndex: "address",
      mobile: "subtitle",
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      title: t("Action"),
      key: "action",
      align: "right",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "edit",
            component: () => <UpdateDepartment data={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => (
              <DeleteModal text="Department" onClick={() => deleteHandler(obj?._id)} />
            )
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={<AddDepartment updateParent={getData} />}
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
    </>
  );
};

export default Departments;
